module.exports = __webpack_public_path__ + "static/media/icon-expand-black.dfac60ff.svg";